export const PORTAL_ACTIVATION = 'activationPortal';
export const ONBOARDING_V1 = 'onboardingV1';
export const ONBOARDING_V2 = 'onboardingV2';
export const ONBOARDING_V2_WITHOUT_MODAL = 'onboardingV2WithoutModal';
export const MIGRATION_COACHING = 'migration-coaching';
export const MIGRATION_TOUR = 'migration-tour';

// Corresponds to flow chart found at https://www.figma.com/design/iWjausQyNCtzXa5JWRmERq/Forecast-by-Multiple-Outcomes-(FMO)?node-id=2524-77259&t=sb0MCPVR8Lj61Kbj-1

export const computeTourToDisplay = ({
  isFmoEnabled,
  isSuperAdmin,
  hasPortalSeenActivationModal,
  hasSeenMigrationTour,
  hasSeenOnboardingV1Tour,
  continueSetup
}) => {
  // Only show portal activation if this is a new forecasting user
  if (!hasPortalSeenActivationModal && !hasSeenOnboardingV1Tour) {
    if (isSuperAdmin && isFmoEnabled) {
      return PORTAL_ACTIVATION;
    }
  }
  if (!hasSeenOnboardingV1Tour) {
    if (!isFmoEnabled) {
      return ONBOARDING_V1;
    }
    if (continueSetup) {
      return ONBOARDING_V2_WITHOUT_MODAL;
    }
    return ONBOARDING_V2;
  }

  // There is nothing new to show for either of these cases
  if (!isFmoEnabled || hasSeenMigrationTour) {
    return null;
  }

  // Case: the user has seen the V1 onboarding tour, but not the migration tour
  if (!isSuperAdmin) {
    return MIGRATION_COACHING;
  }
  return MIGRATION_TOUR;
};